import React from 'react';
import { hideModal } from '../redux/features/oxygen/customModalSlice';
import { useDispatch, useSelector } from 'react-redux';

const OxygenConfirmBundle = ({data}) => {
  const dispatch = useDispatch();
  const {bundle, device_type_id, onClick} = data;
  const otpLoading = useSelector((state) => state.oxygenRetail?.otpLoading);
  const financierID = localStorage.getItem("allAboard-financierid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-financierid"));
  const partnerId = localStorage.getItem("allAboard-partnerid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-partnerid"));

  return (   
  <>
  <div  className="card mb-3 border-0 shadow-md p-3">
    <h6 className="fw-bold text-primary">{bundle?.bundle_name}</h6>
    <ul className="list-unstyled small fw-semibold px-3">
      {
        (Number(financierID) === 20 || Number(partnerId) === 409) && (
        <li className="py-2">
          <strong>Installment Type:</strong>{" "}
          {bundle?.bundle_group}
        </li>
        )
      }
      {
        (Number(financierID) === 20 || Number(partnerId) === 409) ? (
          bundle?.bundle_group?.toLowerCase() === "weekly" ? (
            <li className="py-2"><strong>Weekly Payment:</strong> ₦{bundle?.weekly_payt?.toLocaleString()}</li>
          ):bundle?.bundle_group?.toLowerCase() === "daily" ? (
             <li className="py-2"><strong>Daily Payment:</strong> ₦{bundle?.daily_payt?.toLocaleString()}</li>
          ):bundle?.bundle_group?.toLowerCase() === "monthly" ? (
            <li className="py-2"><strong>Monthly Payment:</strong> ₦{bundle?.monthly_payt?.toLocaleString()}</li>
          ): null
        ) : (
          <li className="py-2"><strong>Monthly Payment:</strong> ₦{bundle?.monthly_payt?.toLocaleString()}</li>
        )
      }
      <li className="py-2"><strong>Down Payment:</strong> ₦{bundle?.down_payt?.toLocaleString()}</li>
      <li className="py-2"><strong>Duration Months:</strong> {bundle?.duration_months}</li>
      {
        (Number(financierID) !== 20 || Number(partnerId) !== 409) &&
        <>
        <li className="py-2"><strong>Voice Minutes:</strong> {bundle?.voice_mins} mins</li>
        </>
      }
      <li className="py-2"><strong>Data Quantity:</strong> {bundle?.data_qty}</li>
      <li className="py-2 font-weight-light">Total Repayment: ₦{bundle?.total_repayt?.toLocaleString()}</li>
    </ul>
    <div className="mt-3 px-3 form-group d-flex justify-content-between">
      <button className="btn btn-secondary" onClick={() => dispatch(hideModal())}>
        <b>Cancel</b>
      </button>
      <button className="btn btn-primary" onClick={() => onClick(bundle, device_type_id )}>{ otpLoading? "Loading..." : "Proceed"}</button>
    </div>
  </div>
  </>
                      
  )
}

export default OxygenConfirmBundle;